import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AccessoryResponse } from '@sales/models/accessory.model';
import { AppData } from '@shared/models/appdata.model';
import { Observable } from 'rxjs';
import { AccessoryFiltersResponse } from '../models/accessory-filters.model';

@Injectable({
  providedIn: 'root',
})
export class AccessoryService {
  private httpClient = inject(HttpClient);
  private appData = inject(AppData);

  getAccessories(): Observable<AccessoryResponse> {
    const url = `${this.appData.apiUrl}/api/v1/product/accessories`;

    return this.httpClient.get<AccessoryResponse>(url);
  }

  getAccessoryFilters(includePcm: boolean, includePim: boolean): Observable<AccessoryFiltersResponse> {
    const url = `${this.appData.apiUrl}/api/v1/product/accessories/filters?includePcm=${includePcm}&includePim=${includePim}`;
    return this.httpClient.get<AccessoryFiltersResponse>(url);
  }
}
